import { render, staticRenderFns } from "./OrderActionButton.vue?vue&type=template&id=38f04188&"
import script from "./OrderActionButton.vue?vue&type=script&lang=js&"
export * from "./OrderActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports